import React from "react";
import { buildRoutes } from "@app/routes/RouteBuilder";
import lazyWithRetry from "@shared/utils/lazyWithRetry";

// Lazy loading con retry automático
const MiPerfilInspector = lazyWithRetry(
  () => import("./ui/MiPerfil"),
  "MiPerfilInspector",
);
const CertificacionesSupervisor = lazyWithRetry(
  () => import("./ui/components/supervisor/CertificacionesSupervisor"),
  "CertificacionesSupervisor",
);

/**
 * Rutas de certificaciones
 */
const certificationsRoutes = buildRoutes([
  {
    path: "/inspector/certificaciones",
    element: MiPerfilInspector,
    roles: [2, 5, 7],
  },
  {
    path: "/supervisor/certificaciones",
    element: CertificacionesSupervisor,
    roles: [3, 5],
  },
]);

export default certificationsRoutes;
